import { render, staticRenderFns } from "./UpdateObjDialog.vue?vue&type=template&id=0f128e54&scoped=true&"
import script from "./UpdateObjDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateObjDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f128e54",
  null
  
)

export default component.exports